import React from 'react';

type SlimWaveDividerProps = {
  /** Match the section above so the strip blends in */
  className?: string;
  /** Gentle motion */
  animated?: boolean;
};

/** Thin glowing blue wave — matches button blue (#2563EB). */
const SlimWaveDivider: React.FC<SlimWaveDividerProps> = ({
  className = '',
  animated = true,
}) => (
  <div
    className={`relative w-full h-7 flex items-center overflow-visible ${className}`}
    aria-hidden="true"
  >
    <svg
      className="w-full h-5 slim-wave-glow"
      viewBox="0 0 1200 20"
      preserveAspectRatio="none"
      fill="none"
    >
      <path
        d="M0,10 C200,18 400,2 600,10 C800,18 1000,2 1200,10"
        stroke="#2563EB"
        strokeWidth="1.75"
        strokeLinecap="round"
      >
        {animated && (
          <animate
            attributeName="d"
            values="
              M0,10 C200,18 400,2 600,10 C800,18 1000,2 1200,10;
              M0,10 C200,2 400,18 600,10 C800,2 1000,18 1200,10;
              M0,10 C200,18 400,2 600,10 C800,18 1000,2 1200,10
            "
            dur="10s"
            repeatCount="indefinite"
          />
        )}
      </path>
    </svg>
  </div>
);

export default SlimWaveDivider;
